import { t } from "i18next";
import React, { Dispatch, SetStateAction } from "react";
import BooleanCategoryPopover from "../../components/Filters/subFilterBooleanPopover";
import CategoryPopover from "../../components/Filters/subFilterPopover";
import { equipmentStatuses } from "../../enums"; // Все состояния статуса оборудования
import { CategoriesType, FilterType } from "../../types/equipmentTypes";

type Props = {
  filterState: [FilterType, Dispatch<SetStateAction<FilterType>>];
  categories: CategoriesType;
};

const Filter = (props: Props) => {
  const producers = props.categories.unique_producer_name;
  const equipment_types = props.categories.unique_equipment_type_name;
  const statuses = props.categories.unique_status; // Список состояний статуса оборудования, существующих в данной выборке
  const divisions = props.categories.unique_division_name;
  const sensors = ["sensors_connected", "sensors_disconnected"]; // Все состояния сенсоров

  const [filter, setFilter] = props.filterState; // Общий фильтр
  const [producersFilter, setProducersFilter] = React.useState(filter.producers); // Подфильтры категорий
  const [typesFilter, setTypesFilter] = React.useState(filter.equipment_type);
  const [statusesFilter, setStatusesFilter] = React.useState(filter.status);
  const [divisionsFilter, setDivisionsFilter] = React.useState(filter.division);
  const [sensorsFilter, setSensorsFilter] = React.useState(filter.sensors);

  React.useEffect(() => {
    setFilter({
      ...filter,
      ...{
        producers: producersFilter,
        equipment_type: typesFilter,
        division: divisionsFilter,
        status: statusesFilter
      },
    });
  }, [producersFilter, typesFilter, statusesFilter, divisionsFilter]);

  React.useEffect(() => {
    setFilter({ ...filter, ...{ sensors: sensorsFilter } });
  }, [sensorsFilter]);

  return (
    <div className="flex gap-2 px-6 mb-2">
      <CategoryPopover
        categoryName={t("producer")}
        content={producers}
        filterState={[producersFilter, setProducersFilter]}
      />
      <CategoryPopover
        categoryName={t("equipment_type_name")}
        content={equipment_types}
        filterState={[typesFilter, setTypesFilter]}
      />
      <CategoryPopover
        categoryName={t("division")}
        content={divisions}
        filterState={[divisionsFilter, setDivisionsFilter]}
      />
      <CategoryPopover
        categoryName={t("status")}
        content={equipmentStatuses}
        filterState={[statusesFilter, setStatusesFilter]}
        searchbar={false}
        fixed={true}
      />
      <BooleanCategoryPopover // Отдельный фильтр с radiogroup элементами
        categoryName={t("with_sensors")}
        content={sensors}
        filterState={[sensorsFilter, setSensorsFilter]}
      />
    </div>
  );
};

export default Filter;
